import { render, staticRenderFns } from "./SupervisorShops.vue?vue&type=template&id=51afc5ae"
import script from "./SupervisorShops.vue?vue&type=script&lang=js"
export * from "./SupervisorShops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports